<template>
  <div id="app">
    <router-link to="/" v-show="$route.params.owner !== undefined">
      <img src="./assets/logo-square-white-on-transparent.svg" style="max-height: 40px; max-width: 100%" class="btn btn-primary p-0 rounded-0" />
    </router-link>
    <header class="bg-primary text-white" style="padding: 156px 0 100px; background-image: url(megan-markham-T0d_OmJ85VI-unsplash.jpg); background-position: 50% 75%; background-size: 100%" v-show="$route.params.owner === undefined">
      <div class="container text-center">
        <router-link to="/"><img src="./assets/logo.svg" style="max-width: 100%" /></router-link>
        <p class="lead">
          <span class="px-2">Simple commercial licenses for open source software</span>
        </p>
      </div>
    </header>
    <Repo v-if="$route.params.owner !== undefined" />
    <section class="pt-4">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 mx-auto mb-4" v-show="$route.params.owner === undefined">
            <p class="lead">
              Open source maintainers aren't a source of limitless unpaid labor.
            </p>
            <p>
              You believe in sharing, but you don't want to be taken advantage of by money-making machines that don't.
            </p>
            <p>
              Dual-licensing your code lets you stay true to your roots while earning grocery money from companies that
              can spare it. 💰
            </p>
            <p class="font-weight-bold">
              What's dual licensing?
            </p>
            <p>
              Dual licensing is saying to the user "here, you choose between these two licenses". One costs nothing but
              has restrictions, like the consuming project must be open source (GPL) or not make money (Creative
              Commons). The other has no such restrictions but puts a few dollars in your pocket.
            </p>
            <GitHubButton v-model="repo" />
            <CurrentLicense v-model="freeLicense" v-show="repo !== null" :repo="repo" />
            <PaidLicense v-model="paidLicense" v-show="freeLicense !== null" :repo="repo" />
            <End v-show="paidLicense !== null" v-if="repo" :repo="repo" />
          </div>
        </div>
      </div>
    </section>
    <footer class="small text-right p-3 fixed-bottom">
      <a href="mailto:hi@license.land" class="btn btn-sm btn-link">Contact</a><br>
    </footer>
  </div>
</template>

<script>
import CurrentLicense from './components/wizard/CurrentLicense.vue'
import End from './components/wizard/End.vue'
import PaidLicense from './components/wizard/PaidLicense.vue'
import GitHubButton from './components/wizard/GitHubButton.vue'
import Repo from './components/Repo.vue'

const scrollDown = function() {
  window.setTimeout(() => window.scrollTo(0, document.body.scrollHeight), 50)
}

export default {
  components: {
    CurrentLicense,
    End,
    GitHubButton,
    PaidLicense,
    Repo,
  },
  data: () => ({
    freeLicense: null,
    paidLicense: null,
    repo: null,
    wizard: null,
  }),
  name: 'app',
  watch: {
    paidLicense: scrollDown(),
  }
}
</script>

<style>
html {
  scroll-behavior: smooth;
}
</style>
